import React, { useEffect, useState } from 'react'

import { Button, Card, CardBody, CardFooter, CardText, Col, Row } from 'reactstrap'
import firebase from "../../firebase/firebase-config";
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import SingleUserCardMonthEarning from './SingleUserCardMonthEarning';

function SingleUserMonthlyEarningByMonth() {
    const params = useParams();
    const [userID, setUUser] = useState({})
    const [all_EarningMonths, setall_EarningMonths] = useState([])

    async function GetMyUser() {
        try {
            const Myuser = await firebase.firestore().collection('users').doc(params.id).get();
            setUUser(Myuser.data());
            Myuser.data();
        } catch (error) {
            console.log(error);
        }



    }
    const getAllMonths = async () => {
        await firebase.firestore().collection('earnings').doc(params.id).collection('totalEarnings').doc(params.month).collection('earnings').onSnapshot(async (momnth) => {

            const allMonthsData = [];

            await momnth.docs.forEach(async (monthe) => {
                await allMonthsData.push(monthe.data())
                console.log(monthe.data(), 'this is sadsa');
            })
            setall_EarningMonths(allMonthsData);
            console.log(allMonthsData);

        })
    }
    useEffect(() => {
        // get_all_ProductsbyUser();
        getAllMonths();
        GetMyUser();
    }, []);
    return (
        <>
            <div className='content'>
                <Row>
                    <Col xs="12">
                        <Row className='mt-4'>
                            <Col className='col-lg-4'>
                            </Col>
                            <Col className='col-lg-4'>
                                <Card className="card-user shadow-lg">

                                    <CardText />
                                    <div className=" d-flex   justify-content-center  " >
                                        <div className=" d-flex ">
                                            <img
                                                alt="..."
                                                className="avatar_single_user"
                                                src={userID.profilePicture}
                                            />
                                            {/* <div>{user?.isOnline == false ? <div className="px-4 d-flex justify-content-center align-items-center  font-weight-bolder" style={{ backgroundColor: '#DD011B', borderRadius: '20px' }}> <p className='font-weight-bold'>Ofline</p>    </div> : <div className="px-4 d-flex justify-content-center align-items-center " style={{ backgroundColor: '#30DF1E', borderRadius: '20px' }}> <p className="font-weight-bold">Online</p>    </div>}
            </div> */}
                                            <div className="ml-2 mt-2">
                                                <div className='d-flex'>
                                                    <p className="description font-weight-bolder" style={{ fontSize: '14px' }}>@{userID.username}</p>
                                                </div>
                                                <p className="description" style={{ fontSize: '12px' }}>{userID.fullName}</p>

                                            </div>

                                        </div>
                                        <div>

                                            <p className="description ml-5 bg-info px-2 ppy-1 rounded " style={{ fontSize: '14px' }}>Beyown user</p>
                                        </div>


                                    </div>


                                </Card>
                                <div className='d-flex justify-content-center  '>
                                    <h3>Earnings For </h3>
                                    <h3 className='bg-primary ml-3 px-3 rounded-2 rounded '>{params.month}</h3>

                                </div>
                            </Col>
                            <Col className='col-lg-4'>
                            </Col>

                        </Row>
                        <div >
                            <div style={{ height: "400px" }} >
                                {/* {all_EarningMonths.length} */}
                                {
                                    all_EarningMonths.map((data, i) => {
                                        return <div><SingleUserCardMonthEarning month={data} key={i} /></div>
                                    })
                                }
                            </div>
                        </div>


                    </Col>
                </Row>

            </div>
        </>
    )
}

export default SingleUserMonthlyEarningByMonth